<template>
  <div class="protocol-field" :style="{ alignItems: alignItems }">
    <input
      ref="checkbox"
      @input="handleChange"
      v-model="isChecked"
      type="checkbox"
    />
    <div class="protocol-list van-multi-ellipsis--l3">
      <span :style="{ color: labelColor }" @click="handleClickLabel">{{
        label
      }}</span>
      <span
        v-for="item in protocolList"
        @click="handleClick(item)"
        :style="{ color: protocolColor }"
        :key="item.id"
        class="span"
        >《{{ item.configName }}》</span
      >
    </div>
    <Popup
      ref="popupBank"
      message="请先绑定收款账户"
      confirmText="去绑卡"
      cancelText="取消"
      @confirm="handleBindBank"
    />
  </div>
</template>
<script>
import { getProtocol, getLoginProtocol, getIdCardProtocol, getBorrowProtocol } from "@/api/index";
import { getLocalStorageData } from "@/common/index";
import Popup from "@/components/Popup/index.vue";

export default {
  name: "protocolField",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "我已阅读并同意",
    },
    labelColor: {
      type: String,
      default: "#999999",
    },
    //协议名称
    protocol: {
      type: String,
      default: "login",
    },
    protocolColor: {
      type: String,
      default: "#F9AE3D",
    },
    //协议类型
    protocolType: {
      type: String,
      default: "3",
    },
    //路由名称
    routerName: {
      type: String,
      default: "Login",
    },
    //对齐方式
    alignItems: {
      type: String,
      default: "center",
    },
    //是否居中
    textCenter: {
      type: Boolean,
      default: true,
    },
    //是否是登录页面
    isLogin: {
      type: Boolean,
      default: false,
    },
    //新绑定银行卡时的银行卡号和银行名称信息
    cardInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Popup,
  },
  data() {
    return {
      isChecked: false,
      protocolList: [],
    };
  },
  activated() {
    if (!this.isChecked && this.$store.state.isChecked) {
      this.isChecked = this.$store.state.isChecked;
      this.getDetails();
    }
  },
  mounted() {
    if (!this.isChecked) {
      this.isChecked = this.$route.params?.isChecked == "1";
      this.getDetails();
    }
  },
  methods: {
    // 获取协议信息
    getDetails(){
      this.$emit("input", this.isChecked);
      if (this.protocolType == 4) {
        //获取实名认证协议信息
        let realNameProtocol = this.$store.state.realNameProtocol;
        getIdCardProtocol({
          type: this.protocolType,
          username: realNameProtocol.ocrName,
          idCardNumber: realNameProtocol.ocrCardNo,
        }).then((res) => {
          if (res.code === 2000) {
            this.protocolList = res.data;
            this.$store.commit("setAgreementList", res.data);
            this.$store.commit("setIsChecked", false);
          } else {
            this.$toast(res.msg || res.message || "请求失败");
          }
        });
        return;
      }
      // 获取借款协议
      if (this.protocolType == 5) {
        getBorrowProtocol({ type: this.protocolType }).then((res) => {
          if (res.code === 2000) {
            this.protocolList = res.data;
            this.$store.commit("setAgreementList", res.data);
            this.$store.commit("setIsChecked", false);
          } else {
            this.$toast(res.msg || res.message || "请求失败");
          }
        });
        return;
      }
      if (!this.isLogin) {
        getLoginProtocol({ type: this.protocolType }).then((res) => {
          if (res.code === 2000) {
            this.protocolList = res.data;
            this.$store.commit("setAgreementList", res.data);
            this.$store.commit("setIsChecked", false);
          } else {
            this.$toast(res.msg || res.message || "请求失败");
          }
        });
      } else {
        getProtocol({ type: this.protocolType }).then((res) => {
          if (res.code === 2000) {
            this.protocolList = res.data;
            this.$store.commit("setAgreementList", res.data);
          } else {
            this.$toast(res.msg || res.message || "请求失败");
          }
        });
      }
    },
    handleBindBank() {
      this.$refs.popupBank.hidePopup();
      this.$nextTick(() => {
        this.$store.state.bankCardBindingFlag = "1";
        this.$router.push({
          name: "bankCardBinding",
        });
      });
    },
    handleClickLabel() {
      if (!this.$store.state.bankInfo?.bankName && this.protocolType == 5) {
        this.$refs.popupBank.showPopup();
        return;
      }
      if(this.protocolType == 6 && (!this.cardInfo?.bankCard || !this.cardInfo?.bankName)) {
        this.$toast("请先添加银行卡信息");
        return;
      }
      //是否需要阅读协议
      let isRead = getLocalStorageData("agreementSigningConditions") == "1";
      if (isRead) {
        this.$router.push({
          name: "agreement",
          query: {
            bankRouter: this.routerName,
            agrType: this.protocolType,
            isLogin: this.isLogin ? "1" : "0",
          },
        });
      } else {
        this.$refs.checkbox.click();
      }
    },
    //点击协议
    handleClick(item) {
      if (!this.$store.state.bankInfo.bankName && this.protocolType == 5) {
        this.$refs.popupBank.showPopup();
        return;
      }
      if(this.protocolType == 6 && (!this.cardInfo?.bankCard || !this.cardInfo?.bankName)) {
        this.$toast("请先添加银行卡信息");
        return;
      }
      this.$router.push({
        name: "agreement",
        query: {
          protocol: item.key,
          bankRouter: this.routerName,
          agrType: this.protocolType,
          isLogin: this.isLogin ? "1" : "0",
          bankCard: this.cardInfo?.bankCard || "",
          bankName: this.cardInfo?.bankName || "",
        },
      });
    },
    handleChange(val) {
      if (!this.$store.state.bankInfo.bankName && this.protocolType == 5) {
         val.target.checked = false;
        this.$refs.popupBank.showPopup();
        return;
      }
      //是否需要阅读协议
      let isRead = getLocalStorageData("agreementSigningConditions") == "1";
      if (isRead) {
        val.target.checked = false;
        this.$emit("input", val.target.checked);
        this.$router.push({
          name: "agreement",
          query: {
            bankRouter: this.routerName,
            agrType: this.protocolType,
          },
        });
      } else {
        this.$emit("input", val.target.checked);
      }
    },
  },
  watch: {
    value(newVal) {
      this.isChecked = newVal;
    },
  },
};
</script>
<style scoped lang="scss">
.protocol-field {
  display: flex;
  margin-top: 20px;
  font-size: 14px;
  color: #999999;
  align-items: center;

  input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid rgba(51, 51, 51, 0.4);
    border-radius: 50%;
    margin-right: 8px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    flex-shrink: 0;

    &:checked {
      background-color: #1d70f7;
      border: none;
      &::after {
        content: "";
        width: 8px;
        height: 4px;
        border: 2px solid #fff;
        border-top: none;
        border-right: none;
        transform: rotate(-45deg);
        margin-top: -2px;
      }
    }
  }

  .span {
    color: #f9ae3d;
    // border-bottom: 1px solid #f9ae3d;
    /* 去掉原本的 border */
    border-bottom: none;

    /* 用内阴影模拟一条在底部的 1px 边线 */
    box-shadow: inset 0 -1px 0 0 #f9ae3d;
  }
}
</style>
